import { Controller, useFormContext } from 'react-hook-form';

import { useTranslate } from '@i18n';
import { Heading4, Select, Stack, Text, u } from '@ui';

import { UserSettingsForm } from '../../UserSettings';

import * as css from './GolfHandicapSection.css';

const handicapOptions = Array.from({ length: 65 }, (_, index) => {
    const value = index - 10;
    return {
        value: String(value),
        label: value < 0 ? `+${Math.abs(value)}` : String(value),
    };
});

export const GolfHandicapSection = () => {
    const t = useTranslate();
    const { control } = useFormContext<UserSettingsForm>();

    return (
        <div className={css.section}>
            <Heading4>{t('user_settings.handicap_section')}</Heading4>

            <div className={css.fieldGrid}>
                <Controller
                    control={control}
                    name="handicap"
                    render={({ field }) => (
                        <Stack gap={u(1)}>
                            <Text variant="pSmall" color="muted" pb={u(1)}>
                                {t('user_settings.handicap_disclaimer')}
                            </Text>
                            <Select
                                options={handicapOptions}
                                selectedValue={String(field.value)}
                                onChange={(values) => field.onChange(Number(values[0] ?? '54'))}
                                label={t('user_settings.handicap_label')}
                                placeholder={t('user_settings.handicap_placeholder')}
                                width="100%"
                            />
                        </Stack>
                    )}
                />
            </div>
        </div>
    );
};
